var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseOrderNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V15.5C0.5 16.6046 1.39543 17.5 2.5 17.5H12.5C13.6046 17.5 14.5 16.6046 14.5 15.5V2.5C14.5 1.39543 13.6046 0.5 12.5 0.5Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V15.5C0.5 16.6046 1.39543 17.5 2.5 17.5H12.5C13.6046 17.5 14.5 16.6046 14.5 15.5V2.5C14.5 1.39543 13.6046 0.5 12.5 0.5Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V15.5C0.5 16.6046 1.39543 17.5 2.5 17.5H12.5C13.6046 17.5 14.5 16.6046 14.5 15.5V2.5C14.5 1.39543 13.6046 0.5 12.5 0.5Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V15.5C0.5 16.6046 1.39543 17.5 2.5 17.5H12.5C13.6046 17.5 14.5 16.6046 14.5 15.5V2.5C14.5 1.39543 13.6046 0.5 12.5 0.5Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V15.5C0.5 16.6046 1.39543 17.5 2.5 17.5H12.5C13.6046 17.5 14.5 16.6046 14.5 15.5V2.5C14.5 1.39543 13.6046 0.5 12.5 0.5Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V15.5C0.5 16.6046 1.39543 17.5 2.5 17.5H12.5C13.6046 17.5 14.5 16.6046 14.5 15.5V2.5C14.5 1.39543 13.6046 0.5 12.5 0.5Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V15.5C0.5 16.6046 1.39543 17.5 2.5 17.5H12.5C13.6046 17.5 14.5 16.6046 14.5 15.5V2.5C14.5 1.39543 13.6046 0.5 12.5 0.5Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V15.5C0.5 16.6046 1.39543 17.5 2.5 17.5H12.5C13.6046 17.5 14.5 16.6046 14.5 15.5V2.5C14.5 1.39543 13.6046 0.5 12.5 0.5Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V15.5C0.5 16.6046 1.39543 17.5 2.5 17.5H12.5C13.6046 17.5 14.5 16.6046 14.5 15.5V2.5C14.5 1.39543 13.6046 0.5 12.5 0.5Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V15.5C0.5 16.6046 1.39543 17.5 2.5 17.5H12.5C13.6046 17.5 14.5 16.6046 14.5 15.5V2.5C14.5 1.39543 13.6046 0.5 12.5 0.5Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V15.5C0.5 16.6046 1.39543 17.5 2.5 17.5H12.5C13.6046 17.5 14.5 16.6046 14.5 15.5V2.5C14.5 1.39543 13.6046 0.5 12.5 0.5Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V15.5C0.5 16.6046 1.39543 17.5 2.5 17.5H12.5C13.6046 17.5 14.5 16.6046 14.5 15.5V2.5C14.5 1.39543 13.6046 0.5 12.5 0.5Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V15.5C0.5 16.6046 1.39543 17.5 2.5 17.5H12.5C13.6046 17.5 14.5 16.6046 14.5 15.5V2.5C14.5 1.39543 13.6046 0.5 12.5 0.5Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5H10.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H10.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H10.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.4961H8.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.4961H8.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.4961H8.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.4961H8.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.4961H8.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.4961H8.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.4961H8.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.4961H8.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.4961H8.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.4961H8.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.4961H8.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.4961H8.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.4961H8.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseOrderNo);
export default __webpack_public_path__ + "static/media/PurchaseOrderNo.2c41eb80c5e35e4fe7aa1fd32b8bfbcd.svg";
export { ForwardRef as ReactComponent };